<div class="preview-card row g-0" (click)="openPreviewModal.next(true)">
  <img 
    *ngIf="content?.banner_image" 
    [src]="content.banner_image | safeValue: 'resource'" 
    alt="Module banner" 
    class="preview-card_banner col-12"
    [ngClass]="{'col-sm-5': !inCreationMode}"
  >
  <div class="preview-card_wrapper col-12" [ngClass]="{'col-sm-6': !inCreationMode && !!content?.banner_image}">
    <div class="preview-card_header">
      <img [src]="'sharpen' | iconByName" alt="">
      <span class="title">{{content?.title}}</span>
    </div>
    
    <div 
      class="preview-card_description p3"
      *ngIf="content?.description?.length" 
      [innerHtml]="content?.description | safeValue: 'html'"
    ></div>
    <ng-container *ngIf="!content?.description?.length && content?.intro">
      <ng-container *ngFor="let item of content?.intro">
        <div *ngIf="item.type === types.PARAGRAPH" [innerHtml]="item.value | safeValue: 'html'"></div>
      </ng-container>
    </ng-container>
    
    <span *ngIf="!inCreationMode" class="preview-card_btn p4">Read More</span>
  </div>
</div>

<app-adaptive-modal [title]="content?.title" [showModal]="openPreviewModal" [fullscreen]="true">
  <div class="preview-card_view">
    <app-sharpen-content
      *ngIf="render"
      [content]="content"
      [creationMode]="inCreationMode"
    ></app-sharpen-content>
  </div>
</app-adaptive-modal>